import React, { PropTypes } from 'react';

import { reviewAbridgedPropType } from '../../proptypes';

import LoadingEllipsis from '../LoadingEllipsis';
import ReviewListItem from './components/ReviewListItem';
import { ArrowLeft, ArrowRight } from '../Iconography';

import { arrow, arrowBtn, arrowBtnDisabled, buttons, list, listItem } from './styles.module.css';

/**
 * Review list presentational component.
 */
const ReviewList = ({ fetching, firstPage, lastPage, onNext, onPrevious, reviews }) => {
  if (reviews) {
    return (
      <section>
        <ul className={list}>
          {reviews.map(review => (
            <li key={review.id} className={listItem}>
              <ReviewListItem {...review} />
            </li>
          ))}
        </ul>
        <div className={buttons}>
          <button
            onClick={onPrevious}
            disabled={firstPage}
            className={firstPage ? arrowBtnDisabled : arrowBtn}
          >
            <ArrowLeft className={arrow} disabled={firstPage} />
          </button>
          <button
            onClick={onNext}
            disabled={lastPage}
            className={lastPage ? arrowBtnDisabled : arrowBtn}
          >
            <ArrowRight className={arrow} disabled={lastPage} />
          </button>
        </div>
      </section>
    );
  }
  if (fetching) {
    return (
      <LoadingEllipsis htmlTag="p" />
    );
  }
  return (
    <p>Could not load reviews</p>
  );
};

ReviewList.propTypes = {
  /**
   * Boolean describing current loading state.
   */
  fetching: PropTypes.bool,
  /**
   * Boolean whether current page is the first.
   */
  firstPage: PropTypes.bool,
  /**
   * Boolean whether current page is the last.
   */
  lastPage: PropTypes.bool,
  /**
   * Function called on next button click.
   */
  onNext: PropTypes.func,
  /**
   * Function called on previous button click.
   */
  onPrevious: PropTypes.func,
  /**
   * Array of review data objects.
   */
  reviews: PropTypes.arrayOf(reviewAbridgedPropType.isRequired),
};

ReviewList.defaultProps = {
  fetching: null,
  firstPage: true,
  lastPage: false,
  onNext: () => {},
  onPrevious: () => {},
  reviews: null,
};

export default ReviewList;



// WEBPACK FOOTER //
// ./app/src/components/ReviewList/index.jsx